<template>
  <p :class="classes" class="paragraph">
    <slot />
  </p>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'md',
      validator: value => ['xs', 'sm', 'md', 'lg'].includes(value)
    },
    spacing: {
      type: String,
      required: false,
      default: null,
      validator: value => ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
    },
    theme: {
      type: String,
      required: false,
      default: null,
      validator: value => ['black', 'dark', 'gray', 'primary', 'white'].includes(value)
    }
  },
  computed: {
    classes() {
      const classes = [`paragraph--${this.size}`];

      if (this.spacing) {
        classes.push(`paragraph--spacing-${this.spacing}`);
      }

      if (this.theme) {
        classes.push(`paragraph--${this.theme}`);
      }

      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.paragraph {
  @include font('open-sans', 'normal');
  line-height: 1.7;
  margin: 0;

  // size
  @each $size in ('xs', 'sm', 'md', 'lg') {
    &--#{$size} {
      @include font-size('paragraph', $size);
    }
  }

  // theme
  @each $theme in ('black', 'dark', 'gray', 'primary', 'white') {
    &--#{$theme} {
      color: color($theme);
    }
  }

  // spacing
  @each $size in map-keys($spacing) {
    &--spacing-#{$size} {
      margin-bottom: spacing($size);
    }
  }

  &__bolder {
    font-weight: 900;
  }
}
</style>
